<script setup lang="ts">
import { computed, ref } from 'vue'

import type { ButtonGroupParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = defineProps<{
  buttonGroup: ButtonGroupParagraph['buttonGroup']
}>()

const selectedOption = ref((() => props.buttonGroup?.findIndex(item => item?.isActive === true) ?? -1)())

const selectElementEnabled = computed(() => (props.buttonGroup?.length ?? 0) >= 6)

const groupHasActive = computed(() => selectedOption.value >= 0)

const getStyleClasses = (isActive = false) => ({
  'bx-button': true,
  'bx-button--active': isActive
})

const buttonTagType = (isActive = false) => isActive ? 'span' : 'a'

const handleOptionChange = () => {
  if (props.buttonGroup?.[selectedOption.value]) {
    window.location.href = props.buttonGroup[selectedOption.value].url ?? '#'
  }
}
</script>

<template>
  <div :class="['bx-content bx-button-group bx-typo--button-group', {'bx-button-group--with-select': selectElementEnabled}]">
    <component :is="buttonTagType(button.isActive)"
               v-for="(button, index) in buttonGroup"
               :key="'buttonGroup-' + index"
               :class="getStyleClasses(button.isActive)"
               :href="button.url">
      {{ button.text }}
    </component>
    <form v-if="selectElementEnabled"
          class="bx-form bx-form--button-group">
      <div class="bx-form__select-wrapper">
        <select v-model="selectedOption"
                class="bx-form__select"
                aria-label="Bitte auswählen"
                title="Bitte auswählen"
                @change="handleOptionChange()">
          <option v-if="!groupHasActive"
                  value="-1"
                  disabled
                  selected>
            Bitte auswählen
          </option>
          <option v-for="(item, index) in buttonGroup"
                  :key="'buttonGroupSelect-' + index"
                  :value="index">
            {{ item.text }}
          </option>
        </select>
        <svg class="icon icon-arrow_toggle">
          <use href="#arrow_toggle" />
        </svg>
      </div>
    </form>
  </div>
</template>
